import React from 'react';
import type { Investment } from '../../../data/mockData';
interface InvestmentSummaryProps {
  investments: Investment[];
}
export function InvestmentSummaryCard({
  investments
}: InvestmentSummaryProps) {
  const totalValue = investments.reduce((s, i) => s + i.value, 0);
  return <div className="mt-3 bg-gray-50 dark:bg-dark-hover rounded-xl p-3" data-id="element-129">
      <div className="flex justify-between items-center mb-3" data-id="element-130">
        <p className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide" data-id="element-131">
          Portfolio
        </p>
        <span className="text-sm font-bold text-gray-900 dark:text-white" data-id="element-132">
          ${totalValue.toLocaleString()}
        </span>
      </div>
      <div className="space-y-2" data-id="element-133">
        {investments.map(inv => <div key={inv.id} className="flex items-center justify-between" data-id="element-134">
            <div className="flex items-center gap-2" data-id="element-135">
              <span className="text-xs font-bold bg-primary-100 dark:bg-primary-900/30 text-primary-600 dark:text-primary-400 px-1.5 py-0.5 rounded" data-id="element-136">
                {inv.symbol}
              </span>
              <span className="text-xs text-gray-600 dark:text-gray-400 truncate max-w-[80px]" data-id="element-137">
                {inv.name.split(' ')[0]}
              </span>
            </div>
            <div className="text-right" data-id="element-138">
              <p className="text-xs font-semibold text-gray-800 dark:text-gray-200" data-id="element-139">
                ${inv.value.toLocaleString()}
              </p>
              <p className={`text-xs ${inv.changePercent >= 0 ? 'text-accent-600 dark:text-accent-400' : 'text-red-500'}`} data-id="element-140">
                {inv.changePercent >= 0 ? '+' : ''}
                {inv.changePercent.toFixed(2)}%
              </p>
            </div>
          </div>)}
      </div>
    </div>;
}